import { render, staticRenderFns } from "./LocalizarClube.vue?vue&type=template&id=3b038b0c"
import script from "./LocalizarClube.vue?vue&type=script&lang=ts"
export * from "./LocalizarClube.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports